import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useSelector } from "react-redux";
import { LoadingButtonSpinner } from "../../../../Spinner/LoadingButtonSpinner";
import { State } from "../../../store/state";
import { StyledNextButton, StyledSubmitButton } from "./NavigationButtons.style";
export const NextButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = t0 => {
  const $ = _c(9);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const loading = useSelector(_temp);
  let t1;
  if ($[3] !== children || $[4] !== loading) {
    t1 = loading ? <LoadingButtonSpinner /> : children;
    $[3] = children;
    $[4] = loading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== t1) {
    t2 = <StyledNextButton {...props}>{t1}</StyledNextButton>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export const SubmitButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = t0 => {
  const $ = _c(9);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const loading = useSelector(_temp2);
  let t1;
  if ($[3] !== children || $[4] !== loading) {
    t1 = loading ? <LoadingButtonSpinner /> : children;
    $[3] = children;
    $[4] = loading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== t1) {
    t2 = <StyledSubmitButton {...props}>{t1}</StyledSubmitButton>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(state) {
  return state.layout.loading;
}
function _temp2(state) {
  return state.layout.loading;
}